<div class="settings-schedule-modal-root" *transloco="let t">
  <button id="close-create-report-icon" (click)="onFailClick()" mat-icon-button class="close-button">
    <mat-icon>cancel</mat-icon>
  </button>

  <div class="title">
    <app-header [hasDashedLine]="false">{{ t('settings-schedule-modal.title') }}</app-header>
    <app-label isGray class="app-label-description">{{t('settings-schedule-modal.description')}}</app-label>
  </div>
  <div class="dashed-line"></div>
  <div mat-dialog-content>
    <div class="form-content">
      <div>
        <app-input id="month-value-input"
                   [type]="'number'"
                   [disabled]="data?.formsDisabled"
                   [fieldName]="'Period'"
                   [label]="labels.monthLabel"
                   [control]="form.controls.pointExpirationPeriodMonths">
        </app-input>
      </div>
      <div>
        <app-input id="schedule-date-input"
                   [disabled]="data?.formsDisabled"
                   [minDate]="minDate"
                   [label]="labels.startsFrom"
                   [control]="form.controls.pointsExpirationEffectiveDate"
                   [datepicker]="startingDate">
        </app-input>
        <mat-datepicker #startingDate></mat-datepicker>
      </div>
    </div>
    <mat-card class="action-card irreversible-card-color mat-elevation-z1"
              *ngIf="data?.currentSettings?.fixedExpirationDate && !data?.formsDisabled">
      <mat-card-content>
        <div class="card-title irreversible-text-color">{{t('settings-schedule-modal.warning-title-1')}}</div>
        <ul class="action-list">
          <li>
            <span class="bullet irreversible-text-color">•</span>
            <span class="irreversible-text-color">{{t('settings-schedule-modal.warning-desc-1')}}</span>
          </li>
        </ul>
      </mat-card-content>
    </mat-card>
    <mat-card class="action-card warning-card-color mat-elevation-z1"
              *ngIf="data?.formsDisabled">
      <mat-card-content>
        <div class="card-title warning-text-color">{{t('settings-schedule-modal.warning-title-2')}}</div>
        <ul class="action-list">
          <li>
            <span class="bullet warning-text-color">•</span>
            <span class="warning-text-color">{{t('settings-schedule-modal.warning-desc-2')}}</span>
          </li>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>
  <div mat-dialog-actions>
    <app-primary-button class="success-button"
                        id="success-dialog-btn"
                        mat-button
                        critical
                        type="submit"
                        [abstractControl]="form"
                        [disabled]="loading || data?.formsDisabled || (data?.systemSettings?.id && !hasChanges)"
                        (clickAction)="saveSchedule()">
      {{ labels.confirm }}
    </app-primary-button>
    <app-primary-button id="fail-dialog-btn"
                        mat-button
                        [disabled]="loading"
                        (clickAction)="onFailClick()">
      {{ labels.cancel }}
    </app-primary-button>
  </div>
</div>
